import React, { useState } from 'react';
import { Card, Row, Col, Badge, Button } from 'react-bootstrap';
import EditCompanyModal from '../modals/EditCompanyModal';
import { RxUpload } from 'react-icons/rx';
import UploadIconModal from '../modals/UploadIconModal';

const CompanyCardDetail = ({ company, reCall }) => {
    const [showEditModal, setShowEditModal] = useState(false);
    const [showEditIconModal, setShowEditIconModal] = useState(false);
    const [iconModalMode, setIconModalMode] = useState('default'); // 'companyFolder' | 'default'

    const handleEditClick = () => {
        setShowEditModal(true);
    };

    const handleModalClose = () => {
        setShowEditModal(false);
        // reCall();
    };
    const handleEditIconClick = (mode = 'default') => {
        setIconModalMode(mode);
        setShowEditIconModal(true);
    };

    const handleModalIconClose = () => {
        setShowEditIconModal(false);
        // reCall();
    };
    return (
        <>
            <div className="d-flex align-items-center justify-content-between">
                <h4 style={{ color: '#4E4E4E' }} className="my-4">
                    Company Info
                </h4>
                <div className='d-flex align-items-center gap-2'>
                    <Button
                        className="d-flex align-items-center px-3 btn-custom fw-bold"
                        onClick={() => handleEditIconClick('companyFolder')}
                        style={{ backgroundColor: "#007bff", borderColor: "#007bff" }}
                        disabled={!company?.name}
                        title={!company?.name ? 'Company name is required to upload to company folder' : 'Upload creatives to company folder'}
                    >
                        <span className="me-2"><RxUpload className='fw-bold' /></span>
                        Upload Creatives In Company Folder
                    </Button>
                    <Button
                        className="d-flex align-items-center px-3 btn-custom fw-bold"
                        onClick={() => handleEditIconClick('default')}
                        style={{ backgroundColor: "#007bff", borderColor: "#007bff" }}
                    >
                        <span className="me-2"><RxUpload className='fw-bold' /></span>
                        Upload Company APP ICONS
                    </Button>
                    <Button
                        className="d-flex align-items-center px-3 btn-custom fw-bold"
                        onClick={handleEditClick}
                        style={{ backgroundColor: "#007bff", borderColor: "#007bff" }}
                    >
                        <span className="me-2">&#9998;</span>
                        Edit Company
                    </Button>
                </div>
            </div>
            <Card className="shadow mb-4 boder-0" style={{ border: 'unset' }}>
                <Card.Body>
                    <Card className="shadow mb-2 border-0 rounded" style={{ background: 'rgb(253 253 253)' }}>
                        <Card.Body>
                            <div className="d-flex align-items-center justify-content-between">
                                <Card.Text as="h3" className="mb-0 fw-bold" style={{ color: '#4E4E4E' }} >
                                    {company?.name}
                                </Card.Text>
                                <Badge
                                    pill
                                    bg={company?.status ? 'success' : 'danger'}
                                    // className="px-3 py-2"
                                    style={{ fontSize: '1rem' }}
                                >
                                    {company?.status ? 'Active' : 'Inactive'}
                                </Badge>
                            </div>
                        </Card.Body>
                    </Card>
                    <Row className='p-4'>
                        <Card.Text as='h4' className="text-secondary fw-bold">Company Information</Card.Text>
                        <Col md={7} className="">
                            <div className='p-2'>
                                <Card.Text className='mb-2 pb-0'>
                                    <strong className='info-head'>Address:</strong> <span className='text-secondary'> {company?.address || 'N/A'}</span>
                                </Card.Text>
                                <Card.Text className='mb-2 pb-0'>
                                    <strong className='info-head'>Country:</strong><span className='text-secondary'> {company?.country || 'N/A'}</span>
                                </Card.Text>
                                <Card.Text className='mb-2 pb-0'>
                                    <strong className='info-head'>Phone:</strong><span className='text-secondary'> {company?.phone || 'N/A'}</span>
                                </Card.Text>
                                <Card.Text className='mb-2 pb-0'>
                                    <strong className='info-head'>Creative Url:</strong><span className='text-secondary'> {company?.creativeUrl || 'N/A'}</span>
                                </Card.Text>
                                <Card.Text className='mb-2 pb-0'>
                                    <strong className='info-head'>Company App Icon Url:</strong><span className='text-secondary'> {company?.appIconUrl || 'N/A'}</span>
                                </Card.Text>
                            </div>
                        </Col>
                        <Col md={5}>
                            <div className='p-2'>
                                <Card.Text className='mb-2 pb-0'>
                                    <strong className='info-head'>Main Sheet Id:</strong><span className='text-secondary'> {company?.sheetId || 'N/A'}</span>
                                </Card.Text>
                                <Card.Text className='mb-2 pb-0'>
                                    <strong className='info-head'>App Category Sheet Id:</strong> <span className='text-secondary'>{company?.categorySheetId || 'N/A'}</span>
                                </Card.Text>
                                <Card.Text>
                                    <strong className='info-head'>Creative Column Name:</strong><span className='text-secondary'> {company?.creativeColumn}</span>
                                </Card.Text>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <EditCompanyModal
                show={showEditModal}
                onHide={handleModalClose}
                company={company}
                reCall={reCall}
            />
            <UploadIconModal
                show={showEditIconModal}
                onHide={handleModalIconClose}
                uploadToCompanyFolder={iconModalMode === 'companyFolder'}
                companyName={company?.name}
            />
        </>
    );
};

export default CompanyCardDetail;
